import { GlFormTextarea } from '@gitlab/ui';
export default {
    name: 'CommitEdit',
    components: {
        GlFormTextarea
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        value: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        inputId: {
            type: String,
            required: true
        }
    },
    emits: [
        'input'
    ]
};
